<template>
  <div
    class="linkflare-loader"
    :class="{ 'linkflare-loader-inline': inline }"
    role="status"
    aria-live="polite"
    :aria-label="label || ariaLabel"
  >
    <img
      src="/linkflare-loading.svg"
      alt=""
      aria-hidden="true"
      class="linkflare-loader-image"
      :style="imageStyle"
    />
    <span v-if="label" class="linkflare-loader-label">{{ label }}</span>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'LinkflareLoader',
  props: {
    label: {
      type: String,
      default: ''
    },
    size: {
      type: [Number, String],
      default: '2.75rem'
    },
    inline: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: 'Loading'
    }
  },
  setup(props) {
    const imageStyle = computed(() => {
      const size = typeof props.size === 'number' ? `${props.size}px` : props.size
      return {
        width: size,
        height: size
      }
    })

    return {
      imageStyle
    }
  }
}
</script>

<style scoped>
.linkflare-loader {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  color: inherit;
  text-align: center;
}

.linkflare-loader-inline {
  flex-direction: row;
  gap: 0.5rem;
  text-align: left;
}

.linkflare-loader-image {
  display: block;
  flex: 0 0 auto;
}

.linkflare-loader-label {
  font: inherit;
  color: inherit;
}
</style>